import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useLocation, useNavigate } from 'react-router'
import { useTranslate } from '@repo/unicity'
import type { MenuItemConfig } from './menu-items'
import { BLUE, BREADCRUMB_GREY } from './constants'

interface BreadcrumbProps {
    activeMenu: MenuItemConfig
}

const Breadcrumb = ({ activeMenu }: BreadcrumbProps) => {
    const navigate = useNavigate()
    const location = useLocation()
    const { translate } = useTranslate()
    const isSkipDeliveryRoute = location.pathname.startsWith('/user/subscriptions/skip-delivery')
    const label = isSkipDeliveryRoute ? translate('skip_next_delivery') : translate(activeMenu.labelKey)

    return (
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: '25px' }} data-testid="breadcrumb-stack-typography-account">
            <Typography
                sx={{ fontSize: 20, color: BREADCRUMB_GREY, cursor: 'pointer' }}
                onClick={() => navigate('/user')}
                data-testid="breadcrumb-typography-account">
                {translate('account')}
            </Typography>
            <Typography sx={{ fontSize: 20, color: BREADCRUMB_GREY }} data-testid="breadcrumb-typography-1">
                ›
            </Typography>
            <Typography
                sx={{
                    fontSize: 20,
                    color: BLUE,
                    fontWeight: 600,
                    cursor: 'default'
                }}
                data-testid="breadcrumb-typography-2">
                {label}
            </Typography>
        </Stack>
    )
}

export default Breadcrumb
